// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"480":"82f800fd","590":"823b22d1"}[chunkId] + ".chunk.js";
};